<section class="pt-80">
    <div class="container-fluid px-0 secondary-footer">

        <div class="container position-relative">
            <img class="secondary-footer-img hide-mobile d-none d-lg-block img-fluid position-absolute bottom-0 left-0"
                 src="assets/components/footer-secondary/footer-img.webp" width="600" alt="" />

            <div class="row no-gutters secondary-footer-content d-flex align-items-center justify-content-center">
                <div class="col-12 col-lg-5 offset-lg-7">
                    <div class="text-white">
                        <div class="d-block mx-auto font-size-16 text-left">
                            <h2>
                                Get <span class="font-italic text-dark">started</span>
                            </h2>
                        </div>
                    </div>
                    <div class="text-white">
                        <div class="d-block mx-auto font-size-16 text-left py-4">
                            The secret to getting ahead is getting started.
                        </div>
                    </div>
                    <div class="text-left py-4">
                        <a routerLink="/course-catalogue">
                            <button type="button" class="btn btn-dark rounded-pill font-size-16 font-weight-bold">
                                View All Courses
                            </button>
                        </a>
                    </div>
                </div>
            </div>
        </div>

    </div>
</section>
